import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ca-form-label',
    templateUrl: './form-label.component.html',
    styleUrls: ['./form-label.component.scss'],
    standalone: false
})
export class FormLabelComponent implements OnInit {
  @Input()
  for: string;

  @Input()
  appendColon: boolean = false;

  @Input()
  bold: boolean = true;

  constructor() {}

  ngOnInit(): void {}
}
